// import React from "react";
// import { Navigate } from "react-router-dom";

// function RequireAuth({ Component }) {
//   console.log(localStorage.getItem("DashBoardUserLoggedIn"));
//   if (!localStorage.getItem("DashBoardUserLoggedIn")) {
//     return <Navigate to="/" />;
//   }
//   return <Component />;
// }
// export default RequireAuth;

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function RequireAuth({ Component }) {
  const { isAuthenticated, isLoading, error } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // You can replace with a proper loading component
  }

  if (error && error.status === 401) {
    return <Navigate to="/login" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Component />;
}

export default RequireAuth;
